import React, { useEffect, useState } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Chip from "@material-ui/core/Chip";
import Container from "@material-ui/core/Container";
import { useStylesHed } from "../../../St/comps/UseStyle";
import EmpoyeesForm from "./Empoyees-form";
import { Toaster } from "react-hot-toast";
import EmpoyeesAppBar from "./Empoyees-appBar";
import customerAPI from "../../../api/customer";
import useFormDataCRUD from "../../../components/Hooks/useEDSCURD";
import {
  defaultCustomer,
  defaultEmployee,
  SyncLocalStorage,
} from "../../../services/global-services";
import { Paper } from "@material-ui/core";
import { insh as inshst } from "../../../Context/InshSt";
import GroupIcon from "@material-ui/icons/Group";
import { useStyleC } from "../../../Fronts/Menues/st/UseStyle";
import { style } from "../../../Fronts/Menues/st/cStyle";
import { useTranslation } from "react-i18next";
import { useAPI } from "../../../api/useAPI";
import EmployeesSalaryData from "./EmployeesSalaryData";
import { sto } from "../../../Context/InshData";

export default function Empoyees(props) {
  const { data, type, fetchURL, isDialog } = props;
  const { createFun, updateFun, removeFun } = useAPI("employee");
  const { t } = useTranslation(["translation", "forms"]);
  const defaultValues = {
    ...defaultEmployee,
    acc_no: props.newAccount,
    type: type,
    branch:sto.branchi,
  };

  const {
    onChange,
    submit,
    update,
    remove,
    submitting,
    errorMessage,
    onShow,
    onEnd,
    object,
    formType,
  } = useFormDataCRUD(
    createFun,
    updateFun,
    removeFun,
    undefined,
    defaultValues,
    null,
    fetchURL
  );

  const title = t("define-employee");
  const title1 = t("forms:add-employee");
  const clashd = useStylesHed();
  const classes = useStyleC();
  const styheader = {
    textAlign: "center",
    backgroundColor: "#f1f1fa",
    direction: "rtl",
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <Toaster />

      <Typography component="div" style={styheader}>
        <Grid item container style={{ paddingBottom: "50px" }}>
          <Grid item xs={12}>
            <Typography
              variant={"h5"}
              component="h3"
              style={{
                marginBlock: 10,
              }}
            >
              {formType == "edit" ? t("forms:edit-employee-data") : title1}
            </Typography>
          </Grid>
          <Grid container  
            justifyContent="space-around"
          >
            <Grid item lg={8} md={8} sm={12}>
              <Container
                component={Paper}
                maxWidth={true}
                style={{
                  paddingTop: "0px",
                  borderColor: "#4a82b9",
                  borderTopWidth: "10px",
                  borderLeftWidth: "0px",
                  borderBottomWidth: "0px",
                  borderRightWidth: "10px",
                  borderStyle: "solid",
                }}
              >
                <Grid container justify="space-between">
                  <Grid item>
                    <Chip
                      size="large"
                      className={clashd.ChipHdUser}
                      label={t("forms:employee-basic-data")}
                    />
                  </Grid>
                  <Grid item>
                    <GroupIcon
                      className={classes.iconCard}
                      style={style.color.user}
                    />
                  </Grid>
                </Grid>

                <EmpoyeesForm
                  {...{
                    ...props,
                    onChange,
                    submit,
                    update,
                    remove,
                    submitting,
                    errorMessage,
                    onShow,
                    onEnd,
                    object,
                    formType,
                  }}
                />
              </Container>
            </Grid>

            <Grid item lg={3} md={3} sm={12}>
              <Container component={Paper} maxWidth={true}
                style={{
                  padding: '10px',
                  paddingTop: '0px',
                  borderColor: "#4a82b9",
                  borderTopWidth: '0px',
                  borderLeftWidth: '0px',
                  borderBottomWidth: '0px',
                  borderRightWidth: '0px',
                  borderStyle: 'solid'
                }}
              >
                <Grid
                  container
                  justify="center"
                  style={{ paddingBottom: '20px' }}
                >
                  <Grid item>
                    <Chip size="large" className={clashd.ChipHdUser} label={t("forms:employee-salary-data")} />
                  </Grid>
                </Grid>

                <EmployeesSalaryData {...{
                  ...props,
                  onChange,
                  submit,
                  update,
                  remove,
                  submitting,
                  errorMessage,
                  onShow,
                  onEnd,
                  object,
                  formType,
                }} />

              </Container>
            </Grid>
            {/* <EmpoyeesTable {...{...props, onShow, Empoyees: data?.Empoyees}}/> */}
          </Grid>
        </Grid>
        <EmpoyeesAppBar
          {...{
            ...props,
            onChange,
            defaultValues,
            submit,
            update,
            remove,
            submitting,
            errorMessage,
            onShow,
            onEnd,
            object,
            formType,
          }}
        />
      </Typography>
    </React.Fragment>
  );
}
